import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.228 3.237h-2.51L8.578 2.1a.744.744 0 0 0-.52-.22h-2.82a2.422 2.422 0 0 0-2.42 2.42v1.92a1.956 1.956 0 0 0-1.4 1.86v4.37a1.959 1.959 0 0 0 1.95 1.95h3.99a1.953 1.953 0 0 0 1.95-1.95v-.09h2.92a2.428 2.428 0 0 0 2.42-2.42V5.647a2.42 2.42 0 0 0-2.42-2.41Zm-4.42 9.21a.455.455 0 0 1-.45.45h-3.99a.455.455 0 0 1-.45-.45v-4.37a.4.4 0 0 1 .1-.26v.29a.749.749 0 0 0 .75.75h3.2a.755.755 0 0 0 .75-.75v-.28a.384.384 0 0 1 .09.25Zm5.34-2.51a.918.918 0 0 1-.92.92h-2.92v-2.78a1.944 1.944 0 0 0-1.95-1.94h-.62a1.551 1.551 0 0 0-1.37-.82 1.482 1.482 0 0 0-1.05.42V4.3a.918.918 0 0 1 .92-.92h2.51l1.13 1.14a.767.767 0 0 0 .53.22h2.82a.915.915 0 0 1 .92.91Z';
const draw24px =
  'M18.32,5.61h-4L12.46,3.77a.71.71,0,0,0-.53-.22H7.62A3.29,3.29,0,0,0,4.33,6.84v3.25a2.59,2.59,0,0,0-2.14,2.55v6.67a2.58,2.58,0,0,0,2.58,2.57h6.11a2.58,2.58,0,0,0,2.58-2.57v-.54h4.86a3.3,3.3,0,0,0,3.3-3.3V8.91A3.3,3.3,0,0,0,18.32,5.61ZM12,19.31a1.09,1.09,0,0,1-1.08,1.07H4.77a1.09,1.09,0,0,1-1.08-1.07V12.64a1.09,1.09,0,0,1,.94-1.08v1.1a.76.76,0,0,0,.75.75h4.89a.76.76,0,0,0,.75-.75v-1.1A1.1,1.1,0,0,1,12,12.64Zm8.16-3.84a1.81,1.81,0,0,1-1.8,1.8H13.46V12.64a2.59,2.59,0,0,0-2.58-2.59H9.68a2,2,0,0,0-3.71,0H5.83V6.84A1.79,1.79,0,0,1,7.62,5.05h4L13.48,6.9a.74.74,0,0,0,.53.21h4.31a1.81,1.81,0,0,1,1.8,1.8Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FolderClipboardIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'folderClipboard')) as IconWithRender;

FolderClipboardIcon.displayName = 'FolderClipboardIcon';
FolderClipboardIcon.propTypes = Icon.propTypes;
FolderClipboardIcon.renderIcon = (props) => <FolderClipboardIcon {...props} />;
export default FolderClipboardIcon;
